module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./providers/device_type'));
  PluginManager.registerAudienceMatcher('device_type', require('./matchers/device_type'));
};
